/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentFormatEnum } from './appointmentFormatEnum';
import { Language } from './language';
import { Practice } from './practice';
import { GenderEnum } from './genderEnum';
import { DurationOption } from './durationOption';
import { SessionTypeEnum } from './sessionTypeEnum';


/**
 * Serializer for the outgoing PlannerFilterView response data.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerFilterViewResponse { 
    readonly sessionTypes: Array<SessionTypeEnum>;
    readonly appointmentFormats: Array<AppointmentFormatEnum>;
    readonly genders: Array<GenderEnum>;
    languages: Array<Language>;
    practices: Array<Practice>;
    durationOptions: Array<DurationOption>;
}
export const PlannerFilterViewResponse_sessionTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerFilterViewResponse_appointmentFormats_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerFilterViewResponse_genders_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerFilterViewResponse_languages_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerFilterViewResponse_practices_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerFilterViewResponse_durationOptions_Validators: ValidatorFn[] =
    [  Validators.required, ];


